import React, { useState, useRef, useEffect } from 'react';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserAccountMenu = () => {
  const navigate = useNavigate();
  const { user, userProfile, signOut, isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  // Don't render anything if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  const userRole = 'Surgeon';
  const userName = 'Dr. Sarah Mitchell';

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
    setIsOpen(false);
  };

  const handleAccountSettings = () => {
    console.log('Account settings action triggered');
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const displayName = userProfile?.full_name || user?.email?.split('@')?.[0] || 'User';
  const displayEmail = user?.email || 'user@example.com';

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={toggleMenu}
        className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-muted transition-colors duration-200"
        aria-label="User account menu"
        aria-expanded={isOpen}
      >
        <div className="flex flex-col items-start">
          <span className="text-sm font-medium text-foreground">{displayName}</span>
          <span className="text-xs text-muted-foreground font-caption">{userRole}</span>
        </div>
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 w-64 bg-popover border border-border rounded-lg shadow-lg z-200 overflow-hidden">
          <div className="p-4 border-b border-border">
            <p className="text-sm font-medium text-popover-foreground">{displayName}</p>
            <p className="text-xs text-muted-foreground font-caption mt-1">{userRole}</p>
          </div>

          <div className="py-2">
            <button
              onClick={handleAccountSettings}
              className="w-full flex items-center px-4 py-3 text-sm text-popover-foreground hover:bg-muted transition-all duration-250"
            >
              <Icon name="Settings" size={18} className="mr-3" />
              Account Settings
            </button>

            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors duration-200"
            >
              <Icon name="LogOut" size={18} />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAccountMenu;